import Vue from 'vue';
import Component from 'vue-class-component';
import { EdTabsHeaderOption } from '@/models/ed-tabs-header-option.model';
import { BOOKSTORE_MENU } from '../../values/bookstore.values';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])

@Component({})
export default class BookstoreView extends Vue {

  public menu: EdTabsHeaderOption[];

  created() {
    this.menu = BOOKSTORE_MENU.map((m: any, i :number) => {
      return new EdTabsHeaderOption({
        ...m,
        label: this.$i18n.t(`bookstore.menu.${m.name}`),
      });
    });
  }

  beforeRouteLeave(to, from, next) {
    next();
  }

}